<template>
  <block-title
    class="order-overview overview"
    :show-line="false"
    title="订单概览"
  >
    <div slot="icon-right" class="block-icon-right" >
      <a-radio-group
        v-model="selectTime"
        button-style="solid"
        class="order-time"
        @change="getOverview"
      >
        <a-radio-button
          v-for="item in timeList"
          :key="item.value"
          :value="item.value"
        >
          {{item.label}}
        </a-radio-button>
      </a-radio-group>
    </div>
    <div class="overview-list flex justify-between">
      <div class="list-item">
        <div class="flex">
          <img class="item-img" src="../imgs/icon_zongxaidanshu.png" />
          <div>
            <p>
              总下单数
            </p>
            <h2>{{orderCnt.total_u_order_cnt}}</h2>
          </div>
        </div>
        <div class="list-item-desc flex">
          <p class="warehose-order-count">仓配
            <span>{{orderCnt.warehouse_delivery_u_order_cnt}}</span>
            单</p>
          <p>纯运输
            <span>{{orderCnt.transport_u_order_cnt}}</span>
            单</p>
        </div>
      </div>
      <div class="list-item">
        <div class="flex">
          <img class="item-img" src="../imgs/icon_xiandanmdds.png" />
          <div>
            <p>
              下单门店订单数
            </p>
            <h2>{{orderCntRatio.current_period_cnt}}</h2>
          </div>
        </div>
        <div class="list-item-desc flex align-center">
          <p>环比</p>
          <span v-if="orderCntRatio.ratio" :class="orderCntRatio.ratio > 0 ? 'rising' : 'falling'">
            <!-- <a-icon :type="orderCntRatio.ratio > 0 ? 'caret-up' : 'caret-down'" theme="filled" /> -->
            <i :class="['iconfont', orderCntRatio.ratio > 0 ? 'icon-up_16x16' : 'icon-down_16x16']" />
            {{(orderCntRatio.ratio*100).toFixed(2)}}%
          </span>
          <span v-else>--</span>
        </div>
      </div>
      <div class="list-item">
        <div class="flex">
          <img class="item-img" src="../imgs/icon_yuguyf.png" />
          <div>
            <p>
              预估运费(元)
            </p>
            <h2>{{transportCost.current_period_transport_cost}}</h2>
          </div>
        </div>
        <div class="list-item-desc flex align-center">
          <p>环比</p>
          <span v-if="transportCost.ratio" :class="transportCost.ratio > 0 ? 'rising' : 'falling'">
            <!-- <a-icon :type="transportCost.ratio > 0 ? 'caret-up' : 'caret-down'" theme="filled" /> -->
            <i :class="['iconfont', transportCost.ratio > 0 ? 'icon-up_16x16' : 'icon-down_16x16']" />
            {{(transportCost.ratio*100).toFixed(2)}}%
          </span>
          <span v-else>--</span>
        </div>
      </div>
      <div class="list-item">
        <div class="flex">
          <img class="item-img" src="../imgs/icon_yiqiansdds.png" />
          <div>
            <p>
              已签收订单数
            </p>
            <h2>{{signOrder.sign_u_order_cnt}}</h2>
          </div>
        </div>
        <div class="list-item-desc flex align-center">
          <p>门店签收次数</p>
          <span>{{signOrder.station_sign_d_oder_cnt}}</span>
        </div>
      </div>
      <div class="list-item">
        <div class="flex">
          <img class="item-img" src="../imgs/icon_jinxingzdds.png" />
          <div>
            <p>
              进行中订单数
            </p>
            <h2>{{orderCnt.processing_u_order_cnt}}</h2>
          </div>
        </div>
        <div class="list-item-desc flex align-center">
          <p>待派车订单数</p>
          <span>{{orderCnt.waiting_dispatch_u_order_cnt}}</span>
        </div>
      </div>
    </div>
  </block-title>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import moment from 'moment'
import base from '@/api/base'
import { orderOverViewData } from '../constant';
import { getOrderCnt, getOrderCntRatio, getTransportCost, getSignOrder } from '../api'

export default {
  name: 'OrderOverview',
  components: {
    BlockTitle
  },
  props: {
    isDemo: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selectTime: '1',
      form: {},
      count: {},
      timeList: [
        {
          label: '今天',
          value: '1'
        },
        {
          label: '近7天',
          value: '7'
        },
        {
          label: '近30天',
          value: '30'
        }
      ],
      orderCnt: {}, // 订单数相关
      orderCntRatio: {}, // 门店下单数（运输）及环比
      transportCost: {}, // 预估运费及环比
      signOrder: {}, // 签收订单数
    }
  },
  created() {
    this.getOverview()
  },
  methods: {
    getOverview() {
      this.orderCnt = {}
      this.orderCntRatio = {}
      this.transportCost = {}
      this.signOrder = {}
      const endTime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      let startTime = ''
      switch(this.selectTime) {
        case '7':
          startTime = moment().subtract(6, "days").startOf('day').format('YYYY-MM-DD HH:mm:ss')
          break
        case '30':
          startTime = moment().subtract(29, "days").startOf('day').format('YYYY-MM-DD HH:mm:ss')
          break
        default:
          startTime = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          break
      }
      const {projectIds,creditCode,customers,customerCode}=this.$store.state.user
      this.form = {
        startTime,
        endTime,
        n: this.selectTime
      }
      if(creditCode){
        const customerCodes=customers.map(item=>item.customerCode)
        this.form={
          ...this.form,
          customerCodes,
          projectIds,
        }
      }else{
        this.form={
          ...this.form,
         customerCode
        }
      }
      this.getCount()
    },
    async getCount() {
      if (this.isDemo) {
        const res = await base.getDictionary({
          status: 1,
          type: 'board_order_desc'
        })
        const data = {
          orderCnt: {},
          orderCntRatio: {},
          signOrder: {},
          transportCost: {},
        }
        res.forEach(item => {
          Object.keys(orderOverViewData).forEach(key => {
            const name = orderOverViewData[key][item.dictionaryName]
            if (name) {
              data[key][name] = item.dictionaryCode
            }
          })
        });
        this.orderCnt = data.orderCnt;
        this.orderCntRatio = data.orderCntRatio;
        this.signOrder = data.signOrder;
        this.transportCost = data.transportCost;
        return
      }
      getOrderCnt(this.form).then(res => { this.orderCnt = res })
      getOrderCntRatio(this.form).then(res => { this.orderCntRatio = res })
      getSignOrder(this.form).then(res => { this.signOrder = res })
      getTransportCost(this.form).then(res => { this.transportCost = res })
    }
  },
}

</script>

<style lang="less" scoped>
.order-overview {
  .overview-list {
    padding: 11px 24px 0 24px;
    .list-item {
      margin-left: 24px;
      flex: 1;
      h2 {
        font-size: 24px;
      }
      .item-img {
        width: 64px;
        height: 64px;
        border-radius: 16px;
        margin-right: 24px;
      }
      .list-item-desc {
        margin-top: 20px;
        p {
          &:first-of-type {
            margin-right: 10px;
          }
          &.warehose-order-count {
            margin-right: 19px;
          }
        }
        span {
          font-size: 18px;
        }
        .rising {
          color: #06B880;
        }
        .falling {
          color: #F56C6C;
        }
      }
    }
  }
}
</style>